import { apiDelete } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";

/**
 * Score Conversion Table 삭제 API 함수
 * @param id Score Conversion Table ID
 * @returns API 응답 객체
 */
export const apiDeleteScoreConversionTable = async (id: string) => {
  const response = await apiDelete<null>(`/score_conversion_tables/${id}`);
  return response.data;
};

/**
 * Score Conversion Table 삭제 Mutation Hook
 */
export const useDeleteScoreConversionTableMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiDeleteScoreConversionTable,
    onSuccess: (data, id) => {
      // 상세 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: QueryKeys.scoreConversionTable.detail(id),
      });
      // 목록 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: QueryKeys.scoreConversionTable.list(),
      });
    },
  });
}; 